import {Component, Input, input, OnInit} from '@angular/core';

import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TooltipModule} from "primeng/tooltip";
import { TextareaModule } from 'primeng/textarea';
import {AbstractProfileComponent} from "../abstract-profile.component";

@Component({
    selector: 'profile-long-textbox',
    imports: [
    ReactiveFormsModule,
    TooltipModule,
    FormsModule,
    TextareaModule
],
    templateUrl: './profile-long-textbox.component.html',
    styleUrl: './profile-long-textbox.component.scss'
})
export class ProfileLongTextboxComponent extends AbstractProfileComponent implements OnInit {

    constructor() {
        super();
    }
}
